import React from "react";
import { Grid, Box, Button } from "@material-ui/core";
import styles from "./subscription.module.css";

export default function CheckoutSubscription(props) {
    const { setProcess, totalPrice, playersCount, year, paymentPlan } = props;
    return (
        <Grid item xs={12} sm={12} md={12} container>
            <Grid item xs={1} sm={1} md={1}>
                <p className={styles.BackText} onClick={() => setProcess(false)}>Back</p>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <Box sx={{ height: 250, display: "flex", alignItems: "flex-end" }}>
                    <Grid item xs={12} sm={12} md={12} container justifyContent="center">
                        <Box sx={{ width: 500, height: 200, backgroundColor: "#E9F1F1", border: "2px solid #0F9BB0", borderRadius: "0.5rem", display: "flex", alignItems: "center", justifyContent: 'center' }}>
                            <Grid item xs={6} sm={6} md={6}>
                                <p className={styles.checkoutTopText}>Subscription Addition</p>
                                <p className={styles.checkoutText1}>${year ? paymentPlan * 10 : paymentPlan}/per player</p>
                                <p className={styles.checkoutText2}>Date: <span className={styles.checkoutText3}>Oct 5, 2022 - March 4, 2022</span></p>
                            </Grid>
                        </Box>
                    </Grid>
                </Box>
                <p className={styles.checkoutText2}>${year ? paymentPlan * 10 : paymentPlan} x <span className={styles.checkoutText3}>{playersCount} patients</span> x <span className={styles.checkoutText3}>{year ? "1 year" : "1 month"}</span></p>
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Grid item xs={3} sm={3} md={3}>
                    <p className={styles.checkoutTopText}>= Total: <span className={styles.checkoutText1}>${totalPrice}</span></p>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Grid item xs={3} sm={3} md={3} style={{ display: "flex", justifyContent: "center" }}>
                    <Box sx={{ height: 70 }}>
                        <Button fullWidth size="large"
                            style={{
                                fontSize: "0.9rem",
                                lineHeight: "1.25rem",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontStyle: "normal",
                                width: 100,
                                height: 40,
                                backgroundColor: "#0F9BB0",
                                color: "white",
                                textTransform: "none",
                            }}>Check out</Button>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}